// extracted by mini-css-extract-plugin
export default {"homeVideo":"HomeVideo_homeVideo__-7s0k"};